import { Colors } from '@sigma-frontend-libs/commons'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'ConfirmDialog',

  mixins: [ proxy() ],

  props: {
    title: {
      type: String,
      default: undefined
    },
    content: {
      type: String,
      default: undefined
    },

    color: {
      type: String,
      default: Colors.error,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },

    loading: Boolean,
    disabled: Boolean,

    callback: {
      type: Function,
      default: undefined
    },

    maxWidth: {
      type: [ String, Number ],
      default: 400
    }
  },

  computed: {
    $_title() {
      return this.title || this.getTranslate('commons.titles.confirm.remove')
    },
    $_content() {
      return this.content || this.getTranslate('commons.contents.confirm.confirm')
    }
  },

  render
}
